import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Отец недоволен. 
        Он возвращается домой чернее тучи; а если он чем-то огорчён, то плакать должны я и сёстры. 
        Он говорит: «Засуха». 
        Он сборщик налогов, а крестьянам в этом году нечем платить налоги: всё посохло. 
      </p>
      
      <p class="mb-3">
        Я и сама вижу: речка так обмелела, что чтобы набрать кувшин, теперь надо стоять нагнувшись, пока не заболят ноги; 
        а раньше речка сама наливала его в одно мгновение…
      </p>
      
      <p class="mb-3">
        Он говорит: «Маис не взошёл, крестьянам нечего есть; и нам скоро не будет. 
        Но если я не соберу налоги, то погибнут не только крестьяне; погибнет само государство, всё разрушится, 
        и койоты будут бегать по пустым улицам». 
      </p>
      
      <p class="mb-3">
        Я боюсь койотов и не хочу умирать от голода. 
        Мне всего 15, я хочу жить. 
        Я столько всего ещё не видела и не знаю!
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>
      

      <p class="mb-3">
        Речка почти совсем пересохла; с полей дует жаркий ветер, полный пыли. 
        Она обжигает, застилает глаза, царапает кожу… 
        Мать уже не подметает в доме: пыль везде, и нет сил бороться с ней, если она появляется снова и снова. 
        Мы едим почти сухой маис с пылью. 
        Нужен дождь.
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>
      

      <p class="mb-3">
        Сегодня отец вернулся особенно озабоченный. 
        Он выгнал нас с сёстрами из комнаты, долго говорил о чём-то с матерью, кричал… 
        Она вышла с заплаканными глазами и долго смотрела на нас, особенно на меня. 
        Меня хотят выдать замуж? 
        Так что же плакать – у меня будет новая жизнь, и, может, в доме мужа будет больше воды и еды? 
        А родители избавятся от одного лишнего рта: и так нас шесть!
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>
      

      <p class="mb-3">
        Умерла Ица, самая младшая сестра. 
        Она как-то высохла и тихо угасла. Она всё время просила пить; но неоткуда взять воды. 
        Даже самые глубокие колодцы пересохли. 
        Теперь оттуда достают только ил и грязь; если их быстро принести домой и выдавливать через тряпку, 
        то получится немного вонючей коричневой воды; но другой нет.
      </p>
      
      <p class="mb-3">
        Город опустел: многие умирают, у большинства просто нет сил выходить из дому. 
        Отец уже несколько дней не ездит в деревни: он говорит, что там, в полях, уже никого не осталось. 
        Там негде спрятаться от солнца, и поля уже все занесло пылью. 
        Теперь отец ходит на заседания Совета, но ничего не говорит нам. Мать еле двигается, и благодарна мне как старшей, что я помогаю ей в доме, 
        хожу за водой… Но жарко, и пока принесёшь домой комочек ила, он, бывает, засохнет…
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>
      

      <p class="mb-3">
        Сегодня отец пришёл домой рано и сразу позвал меня. 
        Я поняла, что он хочет сказать что-то важное, и обрадовалась: наконец-то замуж, в новую жизнь! 
        Но он сказал: «Дочка, ты получишь самого замечательного мужа, божественного мужа. 
        Ты избрана невестой самого Вицлипуцли, бога дождя! 
        Тысячи девушек будут завидовать тебе, когда ты, одетая в прекрасные одежды, осыпанная драгоценностями, вступишь в его царство! 
        Радуйся, ибо ты избрана спасти наш народ!»
      </p>
      
      <p class="mb-3">
        Я окаменела. Так вот какого мужа мне предвещают! 
        Да, пройти в прекрасном одеянии перед всем народом, чтобы все мне рукоплескали, обожали, поклонялись мне… 
        И стать невестой великого бога, который так легко может наслать смерть на весь народ; спасти весь народ и самой стать равной богам…
      </p>
      
      <p class="mb-3">
        Но зачем это мне? Я не хочу пышных одеяний и богатств; я никогда не мечтала о драгоценностях и славе! 
        Я люблю солнце и ветер, реку и заросли на ней. Я хочу жить на земле, а не под землёй или на небе.
      </p>
      
      <p class="mb-3">
        Если Вицлипуцли убивает людей, я не хочу быть его женой!
      </p>
      
      <p class="mb-3">
        Ведь не первый раз приходит засуха, не первый раз собирают девушек, чтобы принести ему в жертву, - и что, он успокоился? 
        Он перестал убивать? 
      </p>
      
      <p class="mb-3">
        Да ему всё равно: он пожирает девушек, пожирает людей, и вообще не обращает внимания на все их действия! 
        Сколько раз после жертвоприношения дождя так и не было! 
        Отец рассказывал: дожди могут не идти и долго после обряда, и сразу перед ним – тогда обряд быстро отменяют, 
        и избранные девушки возвращаются в семьи. 
        Но их никто не берёт замуж, потому что от них отвернулся сам бог – кому же они нужны здесь? 
        Они стареют и умирают в одиночестве, их выгоняют из дому и никто не кормит их. 
      </p>
      
      <p class="mb-3">
        А жрецам не стыдно, что они ошиблись. 
        Они как ни в чём не бывало продолжают далее назначать обряды и выбирать жертв… Избранных? 
        Нет, жертв; и я не хочу быть жертвой!
      </p>
      
      <p class="mb-3">
        Но кто будет спрашивать девушку, хочет она или не хочет быть избранной, невестой, жертвой? 
        Её дело – слушаться и радоваться всему, что ей предпишут на жизненном пути. 
        Она – не человек; она – разменная монета, которой платят… кому? 
        Богу, который творит зло? 
        Или своему неизбывному страху перед этим богом, перед всеми богами, невидимыми, непонятными, которые царят в этом непонятном нам мире? 
        Жрецы совершают обряды, которые ни на что не влияют; но этого никто не замечает, все в отупении верят жрецам, 
        потому что весь мир огромен и непонятен, и нужна же хоть какая-то зацепка, хоть на что-то опираться, во что-то верить! 
        Ну вот, в убийство девушек, например, - а кому нужны эти девушки? 
        Зато, авось, сжалится Вицлипуцли…
      </p>
      
      <p class="mb-3">
        А жрецы безжалостны. 
        Это они выбирают девушек в невесты бога; а откуда они знают, кого хочет бог? 
        Неужели он хочет меня, когда я так ненавижу его, сеющего зло? 
        У меня нет выхода, но я буду сопротивляться до конца. 
        Я не пойду на смерть покорно.
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>
      

      <p class="mb-3">
        Ничто не могло отменить намеченного обряда: ведь дождь так и не пошёл… 
        В назначенный день торжественная процессия направилась к Великому Сеноту. 
        Прекрасные девушки, лучшие в городе, дочери избранных семейств, увенчанные диадемами, осыпанные золотом и драгоценными камнями, 
        сияющими на их одеждах под безжалостным солнцем, были встречены рукоплесканиями народа, оживлённого надеждой. 
        На лицах девушек читался такой же восторг: они избраны для спасения народа, их жертва принесёт жизнь иссушенным полям, умирающим семьям. 
        А как прекрасно стоять так красиво одетой, под восторженными взглядами толпы! 
        Ради одного этого не жалко отдать жизнь! 
        Что они видали в своих домах? 
        Зернотёрки да вшей? 
        А вот пришёл самый великий день их жизни! 
      </p>
      
      <p class="mb-3">
        Процессия приблизилась к Сеноту, и жрецы стали по одной сбрасывать блистательных дев в жерло колодца. 
        Крики девушек сливались с ликующими криками толпы.
      </p>
      
      <p class="mb-3">
        И вдруг одна из них, быстро повернувшись, обхватила ближайшего к ней жреца и вместе с ним бросилась в зияющую бездну. 
      </p>
      
      <p class="mb-3">
        Церемония продолжалась. 
        Ничто не должно нарушать ритуал общения с богом. 
      </p>
      
      <p class="mb-5">
        А назавтра пошёл дождь. 
      </p>
    

      
      <p class="mb-3">
        P.S: «Среди многочисленных черепов девушек, поднятых из Священного Сенота, был найден один-единственный череп, принадлежавший пожилому мужчине. Жрецу?». 
          К. Керам, «Боги, гробницы, учёные», Изд. Иностр. Лит., М, 1960, с.370-371.
      </p>
      
      <p class="mb-3">
        P.Р.S: Бог дождя майя – не Вицлипуцли, а Чак. Но звучит так прозаично, да и совпадает с современным американским именем😒 А нам такие сомнительные намёки не нужны!
        Вицлипуцли – бог войны ацтеков.
      </p>

      
       
    </div>
    `
  )
}

const itemName = {
  rus: `Девушка из Чичен-Ицы`
}

const itemDate = {
  rus: `27 апреля 2020 года`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;